import { __read, __spread } from "tslib";
import { useState, useRef, useCallback, useEffect } from "react";
export function useDefault(value, defaultValue, onChange) {
    var isControlledRef = useRef(false);
    var valueRef = useRef(defaultValue);
    var _a = __read(useState(defaultValue), 2), internalValue = _a[0], setInternalValue = _a[1];
    useEffect(function () {
        if (isControlledRef.current) {
            valueRef.current = value;
        }
    }, [value]);
    var handleInternalChange = useCallback(function (newValue) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // 回调形式更新
        if (typeof newValue === "function") {
            // eslint-disable-next-line no-param-reassign
            newValue = newValue(valueRef.current);
        }
        setInternalValue(newValue);
        valueRef.current = newValue;
        if (typeof onChange === "function") {
            onChange.apply(void 0, __spread([newValue], args));
        }
    }, [onChange]);
    var handleChange = useCallback(function (newValue) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // 回调形式更新
        if (typeof newValue === "function") {
            // eslint-disable-next-line no-param-reassign
            newValue = newValue(valueRef.current);
        }
        if (typeof onChange === "function") {
            onChange.apply(void 0, __spread([newValue], args));
        }
    }, [onChange]);
    // 受控模式
    if (isControlledRef.current || typeof value !== "undefined") {
        isControlledRef.current = true;
        return [value, handleChange];
    }
    // 非受控模式
    return [internalValue, handleInternalChange];
}
//# sourceMappingURL=use-default.js.map